<div>
  @if (imageSrc !== undefined) {
    <img class="small-image" [src]="imageSrc" />
  }
</div>
